<template>
    <div class="form-group mt-2" >
        <label class="form-label">
            {{__t(this.title)}}
        </label>

        <div class="input-group flex-nowrap">
            <b-form-radio-group
                :id="'btn-radios-' + title.toLowerCase()"
                @change="updateValue"
                v-model="localValue"
                button-variant="outline-primary"
                :options="draw_radio_options"
                :name="title.toLowerCase()"
                buttons
            ></b-form-radio-group>
        </div>
    </div>
</template>


<script>
export default {
    name: "yes_no",
    props : {
        title : {
            type : String,
            required : true,
        },

        value : {
            type : [Boolean,String],
            default: false,
        },
        radio_options: {
            type: Array,
            default() {
                return [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false }
                ];
            }
        }
    },
    methods : {
        updateValue() {
            this.$emit('change',this.value);
        }
    },

    computed: {

        draw_radio_options () {
            return this.radio_options.map(item => {
                item.text = this.__t(item.text);
                return item;
            });
        },

        localValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue); // Для Vue 2. В Vue 3 используйте 'update:value'
            }
        }
    }
}
</script>


<style scoped>

</style>
